import { useEffect } from "react";
import CollapseTable from "../../components/tables/CollapseTable";
import { useShops } from "../../hooks/useShops";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { SHOPS_API } from "../../constants/api";
import { limit, orderBy, query } from "firebase/firestore";
import { kTimestamp } from "../../constants/strings";
import {
  getDefaultLimit,
  usePagination,
} from "../../hooks/pagination/usePagination";

export const ShopsRegister = () => {
  const { shopsTableColumns, shopsTableData } = useShops();

  const shopsRef = query(
    SHOPS_API,
    orderBy(kTimestamp, "desc"),
    getDefaultLimit()
  );

  const {
    fetchMore,
    paginatedList: shops,
    getList: getShops,
    loading,
  } = usePagination(shopsRef);

  useEffect(() => {
    getShops();
  }, []);

  return (
    <div>
      <CollapseTable
        loading={loading}
        columns={shopsTableColumns()}
        rows={shopsTableData(shops)}
        fetchMore={fetchMore}
      />
    </div>
  );
};
